import { connectWithStore } from '@common/connectWithStore';
import { getState, load } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { getAccount } from '@redux/ducks/global';
import { PricingPlanPage } from './PricingPlanPage';

const mapStateToProps = state => {
  const { isLoading } = getState(state);
  const account = getAccount(state);

  const isUpgrade = !!(account && account.paymentPlan);
  return {
    isLoading,
    isUpgrade,
  };
};

const mapStateToDispatch = {
  onLoad: load,
};

export const PricingPlanPageContainer = connectWithStore(mapStateToProps, mapStateToDispatch)(PricingPlanPage);
